import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'formik';

const FormField = props => {
  const {
    type,
    componentClasses,
    labelText,
    isTextArea,
    additionalLabelComponent,
    field,
    form: { errors, touched },
  } = props;
  return (
    <div className={componentClasses && componentClasses.fieldContainerClass}>
      {labelText && (
        <label
          htmlFor={field.name}
          className={componentClasses && componentClasses.labelClass}
        >
          {labelText}
        </label>
      )}
      {additionalLabelComponent && additionalLabelComponent()}
      {isTextArea ? (
        <textarea
          className={
            (touched.name && errors.name && componentClasses.errorClass) ||
            (componentClasses && componentClasses.inputClass)
          }
          {...field}
        />
      ) : (
        <input
          type={type}
          autoComplete="on"
          className={
            (touched.name && errors.name && componentClasses.errorClass) ||
            (componentClasses && componentClasses.inputClass)
          }
          {...field}
        />
      )}
      <ErrorMessage name={field.name}>
        {msg => (
          <div className={componentClasses && componentClasses.errorMsgClass}>
            {msg}
          </div>
        )}
      </ErrorMessage>
    </div>
  );
};

FormField.propTypes = {
  type: PropTypes.string,
  labelText: PropTypes.string,
  isTextArea: PropTypes.bool,
  spellCheck: PropTypes.bool,
  meta: PropTypes.object,
  input: PropTypes.object,
  componentClasses: PropTypes.object,
};

export default FormField;
